import React from "react";
import { Table, Space} from "antd";
import { EditFilled } from "@ant-design/icons";
import AppCard from "../../components/AppCard";

const DiagnosisList = () => {
  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <Space size="middle">
          <EditFilled className="icon" />
        </Space>
      ),
    },
  ];

  const data = [
    {
      key: "1",
      name: "John Brown",
      age: 32,
      address: "New York No. 1 Lake Park",
      tags: ["nice", "developer"],
    },
    {
      key: "2",
      name: "Jim Green",
      age: 42,
      address: "London No. 1 Lake Park",
      tags: ["loser"],
    },
    {
      key: "3",
      name: "Joe Black",
      age: 32,
      address: "Sidney No. 1 Lake Park",
      tags: ["cool", "teacher"],
    },
  ];

  return (
    <div>
      <AppCard heading="Diagnosis List">
        <Table columns={columns} dataSource={data} />
      </AppCard>
    </div>
  );
};

export default DiagnosisList;
